import { ReactNode } from 'react';

import { Loading } from '@crossnokaye/ux-common';

import { useAuth } from '@/hooks/use-auth';

interface AuthLoadingBoundaryProps {
  children: ReactNode;
}

/**
 * Shows loading state while Auth0 initializes
 * Single responsibility: Handle loading state
 */
export const AuthLoadingBoundary = ({ children }: AuthLoadingBoundaryProps) => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className={'flex min-h-screen items-center justify-center'}>
        <Loading size={'xl'} />
      </div>
    );
  }

  return <>{children}</>;
};
